import {useEffect, useRef, useState} from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import './lens-selector.css';
import 'swiper/css';
import 'swiper/css/pagination';
import { CAPTURE_METHOD } from "../../constants";

const LensSelector = (props) => {
    const {
        lensIndex, setLensIndex, lenses, captureMethod, capture, recording, recordingPercents
    } = props;
    const recordButtonRef = useRef(null);
    const circleRef = useRef(null);

    // Extract the 'lens' parameter from the URL
    const params = new URLSearchParams(window.location.search);
    const lensParam = params.get('lens');

    // Filter lenses based on the lens parameter
    let filteredLenses;
    console.log(lenses);
    if (lensParam === 'a') {
        filteredLenses = lenses.slice(0, 1);
    } else if (lensParam === 'b') {
        filteredLenses = lenses.slice(1, 2);
    } else if (lensParam === 'c') {
        filteredLenses = lenses.slice(2, 3);
    } else {
        filteredLenses = lenses;
    }

    // Set the initial lens index based on the lens parameter
    useEffect(() => {
        if (lensParam === 'a') {
            setLensIndex(0);
        } else if (lensParam === 'b') {
            setLensIndex(1);
        } else if (lensParam === 'c') {
            setLensIndex(2);
        }
    }, [lensParam, setLensIndex]);

    useEffect(() => {
        if (!circleRef.current) return;
        const radius = circleRef.current.r.baseVal.value;
        const circleLength = 2 * Math.PI * radius;
        const offset = circleLength - recordingPercents / 100 * circleLength;
        circleRef.current.style.strokeDasharray = `${circleLength} ${circleLength}`;
        circleRef.current.style.strokeDashoffset = offset;
    }, [ recordingPercents ]);

    function onSelectLens(e) {
        setLensIndex(e.activeIndex);
    }

    function calcButtonClass() {
        const rec =
            captureMethod === CAPTURE_METHOD.VIDEO && recording ? "_recording" : "";
        return captureMethod.toLowerCase() + rec;
    }

    return <div className="lenses-swiper-container">
        <div className="lens-in-center-inner">
            <svg  width="84" height="84" xmlns="http://www.w3.org/2000/svg" version="1.1">
                <circle ref={circleRef}
                        className="progress-circle-ring"
                        stroke="#E93C5A"
                        strokeWidth="5"
                        cx="42"
                        cy="42"
                        r="38"
                        fill="transparent"/>
            </svg>
        </div>
        <Swiper slidesPerView={5}
                spaceBetween={15}
                initialSlide={lensIndex}
                centeredSlides={true}
                className="lenses-swiper"
                slideToClickedSlide={true}
                onActiveIndexChange={onSelectLens}
                onClick={(swiper, event) => capture(event, recording)}
        >
            {filteredLenses.map((lens, index) => (
                <SwiperSlide key={index} ref={recordButtonRef}>
                    <div className={'active-lens ' + calcButtonClass()}
                    ></div>
                    <img src={lens.iconUrl} style={{ zIndex: 1 }} alt='' />
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
}

export default LensSelector;
